export default __webpack_public_path__ + "static/media/(12).0446f23b.jpg";